import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import _ from 'lodash';
import { getOrganisationData, unsetLoading, setLoading, resetResponseState } from '../../store/appAction';

import { matchSorter } from 'match-sorter';
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';

export default function SelectOrganisation({ organisationId = null, organisationName, disabled, onChange, errors, touched, ...other }) {

    const dispatch = useDispatch();

    // Todo change to get data using TanStack or similar, not from store
    const currentOrganisations = useSelector(state => state.common.organisations);
    const { errorMsg } = useSelector(state => state.common);

    const filterOrgOptions = (options, { inputValue }) => {
        if (options && inputValue) {
            return matchSorter(options, inputValue, { keys: ['id', 'organizationName'] });
        } else if (options) {
            return options
        }
        return []
    }

    useEffect(() => {
        if (!currentOrganisations?.items || currentOrganisations?.items?.length === 0) {
            dispatch(setLoading());
            dispatch(getOrganisationData());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        dispatch(unsetLoading());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentOrganisations]);

    useEffect(() => {
        if (errorMsg) {
            dispatch(unsetLoading());
            dispatch(resetResponseState());
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [errorMsg]);

    const onSelectionChange= (e, value) => {
        onChange(e, value)
    }

    let organisation = null
    if (currentOrganisations?.items?.length > 0 && organisationId ){
        organisation = _.find(currentOrganisations.items, { id: organisationId })
    }else if (organisationId && organisationName){
        organisation= {id:organisationId, organizationName:organisationName}
    }
    return (
            <Autocomplete
                id="organisation-autocomplete"
                disabled={disabled || !currentOrganisations?.items}
                disablePortal
                value={organisation}
                options={currentOrganisations?.items || []}
                getOptionLabel={(org) => `${org?.organizationName}`}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                filterOptions={filterOrgOptions}
                renderOption={(props, option) => {
                    return (
                        <li {...props} key={option.id}>
                            {option.organizationName}
                        </li>
                    );
                }}
                onChange={onSelectionChange}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        fullWidth
                        id="organisationId"
                        name="organisationId"
                        label="Organisation"
                        error={Boolean(errors?.organisationId)}
                        value={organisationId}
                        helperText={touched?.organisationId ? errors?.organisationId : ""}
                    />
                )}
            />
    )

}